module.exports = ".modal {\n  width: 800px; }\n\n.payment-label {\n  min-width: 250px;\n  margin-right: 24px;\n  display: -ms-inline-grid;\n  display: inline-grid; }\n\n.nowrap {\n  white-space: nowrap; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/vendor/my-vendor/payments-view/payment-details-v/payment-details-v.component.scss
// module id = ./src/app/pages/vendor/my-vendor/payments-view/payment-details-v/payment-details-v.component.scss
// module chunks = main